import React from 'react';
import PropTypes from 'prop-types';

import { getPlanDefinition } from '@mssgme/shared';
import Badge from '../Badge';

export const PlanBadge = ({ plan, children, ...rest }) => (
    <Badge badgeStyle="primary" {...rest}>
        {children}
        {getPlanDefinition(plan)?.name || 'PRO'}
    </Badge>
);

PlanBadge.propTypes = {
    ...Badge.propTypes,
    plan: PropTypes.string.isRequired,
};

export default PlanBadge;
